export const LOCAL_STORAGE_BOOL_TRUE_VALUE = 'true'; // local storage only accepts strings

export const userHasLoggedBefore = () => {
  const hasLogged = localStorage.getItem('has-logged-once');
  return !!hasLogged;
};

export const updateLSBoolValue = (id: string, value: boolean) => {
  if (value) {
    localStorage.setItem(id, LOCAL_STORAGE_BOOL_TRUE_VALUE);
  } else {
    localStorage.removeItem(id);
  }
};

export const checkLSBooleanValue = (id: string) => {
  const lsHideMessage = localStorage.getItem(id);
  return lsHideMessage === LOCAL_STORAGE_BOOL_TRUE_VALUE;
};
